import Head from "next/head";
// Components
import { MobileWeb } from "../../components/templates";
import { MerchantContent } from "../../components/organisms";

export default function JoinMerchant() {
  return (
    <MobileWeb>
      {/* SEO */}
      <Head>
        <title>Foodizmart: Join Merchant</title>
        <meta name="description" content="Generated by create next app" />
      </Head>

      {/* Content */}
      <section className="py-4 osahan-main-body">
        <div className="container">

          <MerchantContent />

        </div>
      </section>
    </MobileWeb>
  );
}
